import type {PropsWithChildren, CSSProperties} from 'react'
import ReactModal from 'react-modal'
import {exhaustive} from '@freckle/exhaustive'

export {Header} from './header'
export {Footer} from './footer'
export {Body} from './body'

type Height =
  'small' | 'medium-small' | 'medium' | 'large' | 'fit-content' | {tag: 'rem'; rem: number}
type Width = 'small' | 'medium-small' | 'medium'

type Props = PropsWithChildren<{
  show: boolean
  onHide?: () => void
  width?: Width
  height?: Height
  customStyle?: CSSProperties
}>

const heightStyle = (height: undefined | Height): {height: string; maxHeight?: string} => {
  if (typeof height === 'object' && 'tag' in height) {
    return {height: `${height.rem}rem`}
  }
  switch (height) {
    case 'large':
      return {height: '65vh'}
    case 'medium':
    case undefined:
      return {height: '35vh'}
    case 'medium-small':
      return {height: '30vh'}
    case 'small':
      return {height: '20vh'}
    case 'fit-content':
      return {height: 'fit-content', maxHeight: '90vh'}
    default:
      return exhaustive(height)
  }
}

const widthStyle = (width: undefined | Width): {width: string; left: string} => {
  switch (width) {
    case 'medium':
    case undefined:
      return {width: '40vw', left: '30vw'}
    case 'medium-small':
      return {width: '30vw', left: '35vw'}
    case 'small':
      return {width: '20vw', left: '40vw'}
    default:
      return exhaustive(width)
  }
}

export const Modal = ({show, children, onHide, width, height, customStyle}: Props) => (
  <ReactModal
    isOpen={show}
    onRequestClose={onHide}
    style={{
      content: {
        borderRadius: '0',
        padding: '0',
        // apply default width and height
        ...widthStyle(width),
        ...heightStyle(height),
        // apply custom styles
        ...(customStyle ?? {})
      },
      overlay: {
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        overflow: 'hidden'
      }
    }}
  >
    <div onClick={e => e.stopPropagation()} style={{height: '100%', overflowY: 'auto'}}>
      {children}
    </div>
  </ReactModal>
)
